export const GET_TEMPLATES = [
  {
    id: 1057,
    name: "Test",
    key: null,
    standardized: false,
    group: null,
  },
  {
    id: 1123,
    name: "Test 2",
    key: null,
    standardized: false,
    group: null,
  },
  {
    id: 1124,
    name: "Test 3",
    key: null,
    standardized: false,
    group: null,
  },
  {
    id: 862,
    name: null,
    key: "shoulder_pain",
    standardized: true,
    group: "shoulder",
  },
  {
    id: 863,
    name: null,
    key: "low_back_pain",
    standardized: true,
    group: "back",
  },
  {
    id: 864,
    name: null,
    key: "hand_oa",
    standardized: true,
    group: "hand",
  },
  {
    id: 865,
    name: null,
    key: "trochanterit",
    standardized: true,
    group: "hip",
  },
  {
    id: 866,
    name: null,
    key: "pre_op_knee",
    standardized: true,
    group: "knee",
  },
  {
    id: 867,
    name: null,
    key: "post_op_knee",
    standardized: true,
    group: "knee",
  },
  {
    id: 868,
    name: null,
    key: "pre_op_hip",
    standardized: true,
    group: "hip",
  },
  {
    id: 869,
    name: null,
    key: "post_op_hip",
    standardized: true,
    group: "hip",
  },
  {
    id: 870,
    name: null,
    key: "hip_pain_unspecific",
    standardized: true,
    group: "hip",
  },
  {
    id: 871,
    name: null,
    key: "achilles_tendinopathy",
    standardized: true,
    group: "lower_leg",
  },
  {
    id: 872,
    name: null,
    key: "wrist_pain",
    standardized: true,
    group: "hand",
  },
  {
    id: 859,
    name: null,
    key: "hip_oa",
    standardized: true,
    group: "hip",
  },
  {
    id: 874,
    name: null,
    key: "foot_oa_or_unspecified",
    standardized: true,
    group: "foot",
  },
  {
    id: 875,
    name: null,
    key: "ankle_instability",
    standardized: true,
    group: "foot",
  },
  {
    id: 876,
    name: null,
    key: "lateral_epicondylalgia",
    standardized: true,
    group: "elbow",
  },
  {
    id: 877,
    name: null,
    key: "medial_epicondylalgia",
    standardized: true,
    group: "elbow",
  },
  {
    id: 878,
    name: null,
    key: "patellofemoral_pain_syndrome",
    standardized: true,
    group: "knee",
  },
  {
    id: 879,
    name: null,
    key: "knee_instability",
    standardized: true,
    group: "knee",
  },
  {
    id: 880,
    name: null,
    key: "osteoporosis",
    standardized: true,
    group: "osteoporosis",
  },
  {
    id: 881,
    name: null,
    key: "fall_prevention",
    standardized: true,
    group: "fall_prevention",
  },
  {
    id: 883,
    name: null,
    key: "hallux_valgus",
    standardized: true,
    group: "foot",
  },
  {
    id: 873,
    name: null,
    key: "plantar_faschiit",
    standardized: true,
    group: "foot",
  },
  {
    id: 860,
    name: null,
    key: "knee_oa",
    standardized: true,
    group: "knee",
  },
  {
    id: 861,
    name: null,
    key: "neck",
    standardized: true,
    group: "neck",
  },
];

export const GET_TEMPLATE = {
    "exercises": [
        {
            "id": 1,
            "name": "sit_to_stand",
            "exercise_number": 1,
            "created_at": "2014-12-19T15:54:32Z",
            "updated_at": "2019-03-25T11:25:58Z",
            "duration_minutes": 2,
            "target_joints": [
                "hip",
                "knee",
                "lower_back"
            ],
            "primary_function": "strength",
            "premium": false,
            "introduction_protocol_week": 8,
            "end_protocol_week": null,
            "levels": [
                {
                    "id": 46,
                    "level": 1,
                    "sets": 1,
                    "reps": "15",
                    "exercise_id": 1,
                    "created_at": "2015-02-13T11:16:32Z",
                    "updated_at": "2020-08-20T13:20:37Z",
                    "deprecated_at": null,
                    "equipment": [],
                    "duration_unit": "repetitions",
                    "duration_icon": "repetitions",
                    "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/exercises/Sit-to-stand-1.svg",
                    "video_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/sit-to-stand/level-1/videos.m3u8",
                    "video_thumbnail_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/sit-to-stand/level-1/thumbs_screen.0000057.jpg",
                    "variation_title": null,
                    "instructions_icon_name": "repetitions",
                    "instructions_text1": null,
                    "instructions_text2": "repetitioner",
                    "instructions_text3": null,
                    "tip_title": "Kom igång",
                    "tip_description": "Aktivera dina bålmuskler och håll upp bröstet genom övningen. Tänk också på att du kan anpassa djupet i rörelsen efter din förmåga.\n\nFör en del knakar knäna under denna övning. Det är ofarligt och inget att oroa sig för. ",
                    "title": "Uppresning",
                    "about": "Denna övning stärker dina sätes- och lårmuskler, men involverar också din bålmuskulatur. Sammantaget kommer detta att avlasta dina leder och underlätta dina aktiviteter i vardagen. Som en bonus förbättrar övningen även din hållning och balans.",
                    "caption_file_url": null
                },
                {
                    "id": 47,
                    "level": 2,
                    "sets": 1,
                    "reps": "15",
                    "exercise_id": 1,
                    "created_at": "2015-02-13T11:16:32Z",
                    "updated_at": "2020-08-20T13:20:37Z",
                    "deprecated_at": null,
                    "equipment": [],
                    "duration_unit": "repetitions",
                    "duration_icon": "repetitions",
                    "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/exercises/Sit-to-stand-2.svg",
                    "video_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/sit-to-stand/level-2/videos.m3u8",
                    "video_thumbnail_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/sit-to-stand/level-2/thumbs_screen.0000070.jpg",
                    "variation_title": "En fot framför",
                    "instructions_icon_name": "repetitions",
                    "instructions_text1": "På varje ben",
                    "instructions_text2": "repetitioner",
                    "instructions_text3": null,
                    "tip_title": "Kom ihåg",
                    "tip_description": "För en del knakar knäna under denna övning. Det är ofarligt och inget att oroa sig för. ",
                    "title": "Uppresning",
                    "about": "Denna övning stärker dina sätes- och lårmuskler, men involverar också din bålmuskulatur. Sammantaget kommer detta att avlasta dina leder och underlätta dina aktiviteter i vardagen. Som en bonus förbättrar övningen även din hållning och balans.",
                    "caption_file_url": null
                },
                {
                    "id": 48,
                    "level": 3,
                    "sets": 1,
                    "reps": "15",
                    "exercise_id": 1,
                    "created_at": "2015-02-13T11:16:33Z",
                    "updated_at": "2020-08-20T13:20:37Z",
                    "deprecated_at": null,
                    "equipment": [],
                    "duration_unit": "repetitions",
                    "duration_icon": "repetitions",
                    "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/exercises/Sit-to-stand-3.svg",
                    "video_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/sit-to-stand/level-3/videos.m3u8",
                    "video_thumbnail_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/sit-to-stand/level-3/thumbs_screen.0000066.jpg",
                    "variation_title": "På ett ben",
                    "instructions_icon_name": "repetitions",
                    "instructions_text1": "På varje ben",
                    "instructions_text2": "repetitioner",
                    "instructions_text3": null,
                    "tip_title": "Kom igång",
                    "tip_description": "Denna övning ställer stora krav på din balans. I början kan du sätta ner foten mellan varje repetition eller hålla lätt i ett stöd vid behov.",
                    "title": "Uppresning",
                    "about": "Denna övning stärker dina sätes- och lårmuskler, men involverar också din bålmuskulatur. Sammantaget kommer detta att avlasta dina leder och underlätta dina aktiviteter i vardagen. Som en bonus förbättrar övningen även din hållning och balans.",
                    "caption_file_url": null
                }
            ]
        },
        {
            "id": 10,
            "name": "standing_rotation",
            "exercise_number": 10,
            "created_at": "2018-07-16T09:59:55Z",
            "updated_at": "2019-03-25T11:25:58Z",
            "duration_minutes": 2,
            "target_joints": [
                "hip",
                "lower_back"
            ],
            "primary_function": "mobility",
            "premium": false,
            "introduction_protocol_week": 16,
            "end_protocol_week": null,
            "levels": [
                {
                    "id": 69,
                    "level": 1,
                    "sets": 1,
                    "reps": "15",
                    "exercise_id": 10,
                    "created_at": "2018-07-16T09:59:55Z",
                    "updated_at": "2020-08-20T13:20:37Z",
                    "deprecated_at": null,
                    "equipment": [],
                    "duration_unit": "repetitions",
                    "duration_icon": "repetitions",
                    "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/exercises/Standing-hip-rotation-1.svg",
                    "video_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/hip-rotation/level-1/videos.m3u8",
                    "video_thumbnail_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/hip-rotation/level-1/thumbs_screen.0000069.jpg",
                    "variation_title": null,
                    "instructions_icon_name": "repetitions",
                    "instructions_text1": null,
                    "instructions_text2": "repetitioner",
                    "instructions_text3": null,
                    "tip_title": "Anpassa övningen",
                    "tip_description": "Tänk på att utföra rörelsen lugnt och kontrollerat. Du kan även försöka hålla ytterläget i några sekunder innan du roterar tillbaka.\n\nFör ökad bålstyrka kan du också utföra övningen med en vikt (t ex en vattenflaska) i händerna (tänk att du håller en hand i toppen och en i botten av flaskan rakt ut från kroppen).",
                    "title": "Höftrotation",
                    "about": "För att klara det vardagliga livet, exempelvis att ta på och av strumpor eller gå i och ur bil, är rörligheten i ländrygg och höfter viktig.\n\nI denna övning tränar du på att bibehålla eller öka höftrörligheten vid både inåtrotation och utåtrotation. Övningen kan även kännas bra för din rygg.",
                    "caption_file_url": null
                }
            ]
        },
        {
            "id": 13,
            "name": "leg_lift_side",
            "exercise_number": 13,
            "created_at": "2018-07-16T09:59:55Z",
            "updated_at": "2019-03-25T11:25:58Z",
            "duration_minutes": 2,
            "target_joints": [
                "hip",
                "knee",
                "lower_back"
            ],
            "primary_function": "strength",
            "premium": false,
            "introduction_protocol_week": 6,
            "end_protocol_week": null,
            "levels": [
                {
                    "id": 73,
                    "level": 1,
                    "sets": 2,
                    "reps": "15",
                    "exercise_id": 13,
                    "created_at": "2018-07-16T09:59:55Z",
                    "updated_at": "2020-08-20T13:20:37Z",
                    "deprecated_at": null,
                    "equipment": [],
                    "duration_unit": "repetitions",
                    "duration_icon": "repetitions",
                    "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/exercises/Leg-lift-side-1-2.svg",
                    "video_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/leg-lift-on-side/level-1/videos.m3u8",
                    "video_thumbnail_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/leg-lift-on-side/level-1/thumbs_screen.0000047.jpg",
                    "variation_title": null,
                    "instructions_icon_name": "repetitions",
                    "instructions_text1": "Med varje ben",
                    "instructions_text2": "repetitioner",
                    "instructions_text3": null,
                    "tip_title": "Kom igång",
                    "tip_description": "Var noga med att inte falla bak på rumpan utan verkligen ligga på sidan. Tårna ska peka rakt fram.",
                    "title": "Benlyft på sidan",
                    "about": "I denna övning arbetar du med sätesmuskeln. En stark sätesmuskel är viktig vid höft- och ryggbesvär men även vid knäbesvär då den motverkar att knät faller in mot mitten. En bättre position av knät minskar belastningen på leden.",
                    "caption_file_url": null
                },
                {
                    "id": 74,
                    "level": 2,
                    "sets": 2,
                    "reps": "10",
                    "exercise_id": 13,
                    "created_at": "2018-07-16T09:59:55Z",
                    "updated_at": "2020-08-20T13:20:37Z",
                    "deprecated_at": null,
                    "equipment": [],
                    "duration_unit": "repetitions",
                    "duration_icon": "repetitions",
                    "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/exercises/Leg-lift-side-1-2.svg",
                    "video_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/leg-lift-on-side/level-2/videos.m3u8",
                    "video_thumbnail_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/leg-lift-on-side/level-2/thumbs_screen.0000068.jpg",
                    "variation_title": "Håll benet lyft",
                    "instructions_icon_name": "repetitions",
                    "instructions_text1": "Med varje ben (håll i några sekunder)",
                    "instructions_text2": "repetitioner",
                    "instructions_text3": null,
                    "tip_title": "Anpassa övningen",
                    "tip_description": "För en tuffare övning kan du prova att öka tiden successivt, upp till 10 sekunder. Du kan också sätta på en känga eller fästa en viktmanschett kring din fotled.",
                    "title": "Benlyft på sidan",
                    "about": "I denna övning arbetar du med sätesmuskeln. En stark sätesmuskel är viktig vid höft- och ryggbesvär men även vid knäbesvär då den motverkar att knät faller in mot mitten. En bättre position av knät minskar belastningen på leden.",
                    "caption_file_url": null
                }
            ]
        },
        {
            "id": 14,
            "name": "leg_lift_stomach",
            "exercise_number": 14,
            "created_at": "2018-07-16T09:59:55Z",
            "updated_at": "2019-03-25T11:25:58Z",
            "duration_minutes": 2,
            "target_joints": [
                "hip",
                "knee",
                "lower_back"
            ],
            "primary_function": "strength",
            "premium": false,
            "introduction_protocol_week": 11,
            "end_protocol_week": null,
            "levels": [
                {
                    "id": 75,
                    "level": 1,
                    "sets": 2,
                    "reps": "15",
                    "exercise_id": 14,
                    "created_at": "2018-07-16T09:59:55Z",
                    "updated_at": "2020-08-20T13:20:37Z",
                    "deprecated_at": null,
                    "equipment": [],
                    "duration_unit": "repetitions",
                    "duration_icon": "repetitions",
                    "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/exercises/Leg-lift-stomach-1-2.svg",
                    "video_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/leg-lift-on-stomach/level-1/videos.m3u8",
                    "video_thumbnail_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/leg-lift-on-stomach/level-1/thumbs_screen.0000069.jpg",
                    "variation_title": null,
                    "instructions_icon_name": "repetitions",
                    "instructions_text1": "Med varje ben",
                    "instructions_text2": "repetitioner",
                    "instructions_text3": null,
                    "tip_title": "Kom igång",
                    "tip_description": "Tänk på att spänna magen och att inte lyfta benet högre än att båda höfterna ligger an mot underlaget.",
                    "title": "Benlyft på mage",
                    "about": "I denna övning arbetar du med mag- och ländryggsmuskler, sätesmuskeln och muskeln på lårets baksida.<br><br>De senare är viktiga komponenter i den muskelkorsett som omger knän och höfter och som behövs för att avlasta dina leder när du står och går.",
                    "caption_file_url": null
                },
                {
                    "id": 76,
                    "level": 2,
                    "sets": 2,
                    "reps": "10",
                    "exercise_id": 14,
                    "created_at": "2018-07-16T09:59:55Z",
                    "updated_at": "2020-08-20T13:20:37Z",
                    "deprecated_at": null,
                    "equipment": [],
                    "duration_unit": "repetitions",
                    "duration_icon": "repetitions",
                    "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/exercises/Leg-lift-stomach-1-2.svg",
                    "video_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/leg-lift-on-stomach/level-2/videos.m3u8",
                    "video_thumbnail_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/leg-lift-on-stomach/level-2/thumbs_screen.0000052.jpg",
                    "variation_title": "Håll benet lyft",
                    "instructions_icon_name": "repetitions",
                    "instructions_text1": "Med varje ben (håll i några sekunder)",
                    "instructions_text2": "repetitioner",
                    "instructions_text3": null,
                    "tip_title": "Anpassa övningen",
                    "tip_description": "För en ännu tuffare övning kan du med tiden prova att öka tiden successivt, upp till 10 sekunder. Du kan också sätta på en känga eller fästa en viktmanschett kring din fotled.",
                    "title": "Benlyft på mage",
                    "about": "I denna övning arbetar du med mag- och ländryggsmuskler, sätesmuskeln och muskeln på lårets baksida.<br><br>De senare är viktiga komponenter i den muskelkorsett som omger knän och höfter och som behövs för att avlasta dina leder när du står och går.",
                    "caption_file_url": null
                }
            ]
        },
        {
            "id": 15,
            "name": "lunges",
            "exercise_number": 15,
            "created_at": "2018-07-16T09:59:55Z",
            "updated_at": "2019-03-25T11:25:58Z",
            "duration_minutes": 2,
            "target_joints": [
                "hip",
                "knee",
                "lower_back",
                "lower_leg",
                "foot"
            ],
            "primary_function": "strength",
            "premium": false,
            "introduction_protocol_week": 10,
            "end_protocol_week": null,
            "levels": [
                {
                    "id": 77,
                    "level": 1,
                    "sets": 2,
                    "reps": "15",
                    "exercise_id": 15,
                    "created_at": "2018-07-16T09:59:55Z",
                    "updated_at": "2020-08-20T13:20:37Z",
                    "deprecated_at": null,
                    "equipment": [],
                    "duration_unit": "repetitions",
                    "duration_icon": "repetitions",
                    "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/exercises/Lunges-1.svg",
                    "video_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/lunges/level-1/videos.m3u8",
                    "video_thumbnail_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/lunges/level-1/thumbs_screen.0000059.jpg",
                    "variation_title": null,
                    "instructions_icon_name": "repetitions",
                    "instructions_text1": "På varje sida",
                    "instructions_text2": "repetitioner",
                    "instructions_text3": null,
                    "tip_title": "Kom igång med rörelsen",
                    "tip_description": "Prova lite olika steglängder för att hitta den position som känns bäst. Aktivera dina bålmuskler och håll överkroppen rak genom övningen.\n\nTill en början kan du också hålla i dig i t.ex. diskbänken eller ett bord för att med hjälp av handen bromsa på vägen ned och sedan avlasta lederna genom att trycka lätt på vägen upp.",
                    "title": "Utfall",
                    "about": "I denna övning arbetar du med styrkan i lårets fram- och baksida samt i säte och bål - en riktigt bra övning på många sätt. Dels får du jobba med bålmuskulaturen för att hålla balansen, dels stärker du den muskelkorsett som omger knän och höfter och som behövs för att avlasta dina leder när du står och går. Dessutom arbetar du mycket med sätesmusklerna vilka ofta är en svag länk vid rygg, höft och knäbesvär.<br><br>Detta är en utmanande övning så oroa dig inte om det tar emot lite i början - och skulle dina knän knaka är det inte heller farligt.",
                    "caption_file_url": null
                },
                {
                    "id": 78,
                    "level": 2,
                    "sets": 2,
                    "reps": "15",
                    "exercise_id": 15,
                    "created_at": "2018-07-16T09:59:55Z",
                    "updated_at": "2020-08-20T13:20:37Z",
                    "deprecated_at": null,
                    "equipment": [],
                    "duration_unit": "repetitions",
                    "duration_icon": "repetitions",
                    "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/exercises/Lunges-2.svg",
                    "video_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/lunges/level-2/videos.m3u8",
                    "video_thumbnail_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/lunges/level-2/thumbs_screen.0000050.jpg",
                    "variation_title": "Gå ner djupt",
                    "instructions_icon_name": "repetitions",
                    "instructions_text1": "På varje sida",
                    "instructions_text2": "repetitioner",
                    "instructions_text3": null,
                    "tip_title": "Kom igång med rörelsen",
                    "tip_description": "Anpassa djupet efter din förmåga och ta stöd av något om du behöver hjälp med balansen.",
                    "title": "Utfall",
                    "about": "I denna övning arbetar du med styrkan i lårets fram- och baksida samt i säte och bål - en riktigt bra övning på många sätt. Dels får du jobba med bålmuskulaturen för att hålla balansen, dels stärker du den muskelkorsett som omger knän och höfter och som behövs för att avlasta dina leder när du står och går. Dessutom arbetar du mycket med sätesmusklerna vilka ofta är en svag länk vid rygg, höft och knäbesvär.<br><br>Detta är en utmanande övning så oroa dig inte om det tar emot lite i början - och skulle dina knän knaka är det inte heller farligt.",
                    "caption_file_url": null
                },
                {
                    "id": 79,
                    "level": 3,
                    "sets": 2,
                    "reps": "15",
                    "exercise_id": 15,
                    "created_at": "2018-07-16T09:59:55Z",
                    "updated_at": "2020-08-20T13:20:37Z",
                    "deprecated_at": null,
                    "equipment": [],
                    "duration_unit": "repetitions",
                    "duration_icon": "repetitions",
                    "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/exercises/Lunges-3.svg",
                    "video_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/lunges/level-3/videos.m3u8",
                    "video_thumbnail_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/lunges/level-3/thumbs_screen.0000054.jpg",
                    "variation_title": "På ett ben",
                    "instructions_icon_name": "repetitions",
                    "instructions_text1": "Med varje ben",
                    "instructions_text2": "repetitioner",
                    "instructions_text3": null,
                    "tip_title": "Anpassa övningen",
                    "tip_description": "För en ännu tuffare övning kan du prova att hålla ett par vattenflaskor eller hantlar i händerna.",
                    "title": "Utfall",
                    "about": "I denna övning arbetar du med styrkan i lårets fram- och baksida samt i säte och bål - en riktigt bra övning på många sätt. Dels får du jobba med bålmuskulaturen för att hålla balansen, dels stärker du den muskelkorsett som omger knän och höfter och som behövs för att avlasta dina leder när du står och går. Dessutom arbetar du mycket med sätesmusklerna vilka ofta är en svag länk vid rygg, höft och knäbesvär.<br><br>Detta är en utmanande övning så oroa dig inte om det tar emot lite i början - och skulle dina knän knaka är det inte heller farligt.",
                    "caption_file_url": null
                }
            ]
        },
        {
            "id": 18,
            "name": "bridge",
            "exercise_number": 18,
            "created_at": "2020-01-30T11:39:17Z",
            "updated_at": "2020-01-30T11:39:17Z",
            "duration_minutes": 2,
            "target_joints": [
                "hip",
                "knee",
                "lower_back"
            ],
            "primary_function": "strength",
            "premium": false,
            "introduction_protocol_week": 4,
            "end_protocol_week": null,
            "levels": [
                {
                    "id": 101,
                    "level": 1,
                    "sets": 2,
                    "reps": "15",
                    "exercise_id": 18,
                    "created_at": "2020-01-30T11:39:17Z",
                    "updated_at": "2020-08-20T13:20:37Z",
                    "deprecated_at": null,
                    "equipment": [],
                    "duration_unit": "repetitions",
                    "duration_icon": "repetitions",
                    "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/exercises/Bridge-1.svg",
                    "video_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/bridge/level-1/videos.m3u8",
                    "video_thumbnail_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/bridge/level-1/thumbs_screen.0000117.jpg",
                    "variation_title": null,
                    "instructions_icon_name": "repetitions",
                    "instructions_text1": null,
                    "instructions_text2": "repetitioner",
                    "instructions_text3": null,
                    "tip_title": "Anpassa övningen",
                    "tip_description": "För att göra övningen lite tuffare, prova att lägga händerna över bröstet.",
                    "title": "Höftlyft",
                    "about": "I den här övningen arbetar du med styrkan i bål, säte, samt lårets baksida. Genom att bygga upp styrka i dessa muskler avlastar du dina leder och det blir lättare att utföra dina aktiviteter i vardagen.",
                    "caption_file_url": null
                },
                {
                    "id": 102,
                    "level": 2,
                    "sets": 2,
                    "reps": "15",
                    "exercise_id": 18,
                    "created_at": "2020-01-30T11:39:17Z",
                    "updated_at": "2020-08-20T13:20:37Z",
                    "deprecated_at": null,
                    "equipment": [],
                    "duration_unit": "repetitions",
                    "duration_icon": "repetitions",
                    "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/exercises/Bridge-2.svg",
                    "video_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/bridge/level-2/videos.m3u8",
                    "video_thumbnail_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/bridge/level-2/thumbs_screen.0000117.jpg",
                    "variation_title": "Med höjt ben",
                    "instructions_icon_name": "repetitions",
                    "instructions_text1": "Med varje ben",
                    "instructions_text2": "repetitioner",
                    "instructions_text3": null,
                    "tip_title": "Anpassa övningen",
                    "tip_description": "För att göra övningen lite tuffare, prova att lägga händerna över bröstet.",
                    "title": "Höftlyft",
                    "about": "I den här övningen arbetar du med styrkan i bål, säte, samt lårets baksida. Genom att bygga upp styrka i dessa muskler avlastar du dina leder och det blir lättare att utföra dina aktiviteter i vardagen.",
                    "caption_file_url": null
                },
                {
                    "id": 274,
                    "level": 3,
                    "sets": 1,
                    "reps": "15",
                    "exercise_id": 18,
                    "created_at": "2023-10-24T07:02:22Z",
                    "updated_at": "2023-10-24T07:02:22Z",
                    "deprecated_at": null,
                    "equipment": [
                        "resistance_band"
                    ],
                    "duration_unit": "repetitions",
                    "duration_icon": "repetitions",
                    "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/exercises/Bridge-3.svg",
                    "video_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20231011/global/bridge/level-3/videos.m3u8",
                    "video_thumbnail_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20231011/global/bridge/level-3/thumbs_screen.0000040.jpg",
                    "variation_title": "Med träningsband",
                    "instructions_icon_name": "repetitions",
                    "instructions_text1": null,
                    "instructions_text2": "repetitioner",
                    "instructions_text3": null,
                    "tip_title": "Kom igång",
                    "tip_description": "Tänk på att inte skjuta upp höfterna för högt så att ryggen hamnar i svank. Försök att hålla bålen spänd och ryggen rak.",
                    "title": "Höftlyft",
                    "about": "I den här övningen arbetar du med styrkan i bål, säte, samt lårets baksida. Genom att bygga upp styrka i dessa muskler avlastar du dina leder och det blir lättare att utföra dina aktiviteter i vardagen.",
                    "caption_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20231011/global/bridge/level-3/caption-sv.vtt"
                }
            ]
        },
        {
            "id": 19,
            "name": "bird_dog",
            "exercise_number": 19,
            "created_at": "2020-01-30T11:39:17Z",
            "updated_at": "2020-01-30T11:39:17Z",
            "duration_minutes": 2,
            "target_joints": [
                "hip",
                "knee",
                "lower_back",
                "shoulder",
                "neck"
            ],
            "primary_function": "strength",
            "premium": false,
            "introduction_protocol_week": 1,
            "end_protocol_week": null,
            "levels": [
                {
                    "id": 104,
                    "level": 1,
                    "sets": 2,
                    "reps": "15",
                    "exercise_id": 19,
                    "created_at": "2020-01-30T11:39:17Z",
                    "updated_at": "2020-08-20T13:20:37Z",
                    "deprecated_at": null,
                    "equipment": [],
                    "duration_unit": "repetitions",
                    "duration_icon": "repetitions",
                    "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/exercises/Bird-dog-1.svg",
                    "video_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/bird-dog/level-1/videos.m3u8",
                    "video_thumbnail_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/bird-dog/level-1/thumbs_screen.0000050.jpg",
                    "variation_title": null,
                    "instructions_icon_name": "repetitions",
                    "instructions_text1": "Med varje ben",
                    "instructions_text2": "repetitioner",
                    "instructions_text3": null,
                    "tip_title": "Kom igång",
                    "tip_description": "Det går lika bra att göra varannan höger, varannan vänster i denna övning, bara du ser till att det blir 15 repetitioner med varje ben.",
                    "title": "Fågelhunden",
                    "about": "I den här övningen arbetar du med musklerna kring skulderbladet, ryggen, bålen, sätet och baksida lår. Det är därför en mycket bra övning för en rad olika besvär.",
                    "caption_file_url": null
                },
                {
                    "id": 105,
                    "level": 2,
                    "sets": 2,
                    "reps": "15",
                    "exercise_id": 19,
                    "created_at": "2020-01-30T11:39:17Z",
                    "updated_at": "2020-08-20T13:20:37Z",
                    "deprecated_at": null,
                    "equipment": [],
                    "duration_unit": "repetitions",
                    "duration_icon": "repetitions",
                    "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/exercises/Bird-dog-2.svg",
                    "video_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/bird-dog/level-2/videos.m3u8",
                    "video_thumbnail_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/bird-dog/level-2/thumbs_screen.0000040.jpg",
                    "variation_title": "Med lyft arm",
                    "instructions_icon_name": "repetitions",
                    "instructions_text1": "Med varje ben och motsatt arm",
                    "instructions_text2": "repetitioner",
                    "instructions_text3": null,
                    "tip_title": "Kom igång",
                    "tip_description": "Tänk på att hålla arm, kropp och ben i en rak linje. Lyft inte över “horisonten” för att undvika att svanka. Om du inte kan lyfta armarna till horisontlinjen, lyft så högt du kan. ",
                    "title": "Fågelhunden",
                    "about": "I den här övningen arbetar du med musklerna kring skulderbladet, ryggen, bålen, sätet och baksida lår. Det är därför en mycket bra övning för en rad olika besvär.",
                    "caption_file_url": null
                },
                {
                    "id": 275,
                    "level": 3,
                    "sets": 1,
                    "reps": "15",
                    "exercise_id": 19,
                    "created_at": "2023-10-24T07:02:22Z",
                    "updated_at": "2023-10-24T07:02:22Z",
                    "deprecated_at": null,
                    "equipment": [
                        "resistance_band"
                    ],
                    "duration_unit": "repetitions",
                    "duration_icon": "repetitions",
                    "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/exercises/Bird-dog-3.svg",
                    "video_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20231011/global/bird-dog/level-3/videos.m3u8",
                    "video_thumbnail_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20231011/global/bird-dog/level-3/thumbs_screen.0000041.jpg",
                    "variation_title": "Med träningsband",
                    "instructions_icon_name": "repetitions",
                    "instructions_text1": "Med varje ben.",
                    "instructions_text2": "repetitioner",
                    "instructions_text3": null,
                    "tip_title": "Anpassa övningen",
                    "tip_description": "Det går lika bra att göra varannan höger, varannan vänster i denna övning. Bara se till att det blir 15 repetitioner med varje ben.",
                    "title": "Fågelhunden",
                    "about": "I den här övningen arbetar du med musklerna kring skulderbladet, ryggen, bålen, sätet och baksida lår. Det är därför en mycket bra övning för en rad olika besvär.",
                    "caption_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20231011/global/bird-dog/level-3/caption-sv.vtt"
                }
            ]
        },
        {
            "id": 20,
            "name": "lying_core_strengthener",
            "exercise_number": 20,
            "created_at": "2021-02-23T08:12:10Z",
            "updated_at": "2021-02-23T08:12:10Z",
            "duration_minutes": 0,
            "target_joints": [
                "hip",
                "lower_back"
            ],
            "primary_function": "strength",
            "premium": false,
            "introduction_protocol_week": 1,
            "end_protocol_week": null,
            "levels": [
                {
                    "id": 107,
                    "level": 1,
                    "sets": 0,
                    "reps": "15",
                    "exercise_id": 20,
                    "created_at": "2021-02-23T08:12:10Z",
                    "updated_at": "2021-02-23T08:12:10Z",
                    "deprecated_at": null,
                    "equipment": [],
                    "duration_unit": "repetitions",
                    "duration_icon": "repetitions",
                    "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/exercises/Lying-core-strengthener-1.svg",
                    "video_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20220309/sv/lying-core-strengthener/level-1/videos.m3u8",
                    "video_thumbnail_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20220309/sv/lying-core-strengthener/level-1/thumbs_screen.0000052.jpg",
                    "variation_title": null,
                    "instructions_icon_name": "repetitions",
                    "instructions_text1": "På varje sida",
                    "instructions_text2": "repetitioner",
                    "instructions_text3": null,
                    "tip_title": "Kom igång",
                    "tip_description": "Håll fingrarna precis innanför höftkammen och känn efter att du verkligen aktiverar magmusklerna. Undvik att vika ut benet så långt åt sidan att du får svårt att hålla kroppen stilla.\n\nDu kan även göra den här övningen i en fast säng eller soffa.",
                    "title": "Liggande bålstärkaren",
                    "about": "I denna övning tränar du främst de inre magmusklerna. Det är musklerna som går horisontellt som ett bälte över magen, samt de små muskler som går mellan kotorna i ryggen. Att vara stark i de inre musklerna ger kotpelaren ett stöd.",
                    "caption_file_url": null
                },
                {
                    "id": 108,
                    "level": 2,
                    "sets": 0,
                    "reps": "15",
                    "exercise_id": 20,
                    "created_at": "2021-02-23T08:12:10Z",
                    "updated_at": "2021-02-23T08:12:10Z",
                    "deprecated_at": null,
                    "equipment": [],
                    "duration_unit": "repetitions",
                    "duration_icon": "repetitions",
                    "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/exercises/Lying-core-strengthener-2.svg",
                    "video_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/lying-core-strengthener/level-2/videos.m3u8",
                    "video_thumbnail_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/lying-core-strengthener/level-2/thumbs_screen.0000064.jpg",
                    "variation_title": "Med armar",
                    "instructions_icon_name": "repetitions",
                    "instructions_text1": null,
                    "instructions_text2": "repetitioner",
                    "instructions_text3": null,
                    "tip_title": "Anpassa övningen",
                    "tip_description": "Du kan börja med bara en arm i taget. Håll den andra handen precis innanför höftkammen för att känna efter med fingrarna att du verkligen spänner magmusklerna. ",
                    "title": "Liggande bålstärkaren",
                    "about": "I denna övning tränar du främst de inre magmusklerna. Det är musklerna som går horisontellt som ett bälte över magen, samt de små muskler som går mellan kotorna i ryggen. Att vara stark i de inre musklerna ger kotpelaren ett stöd.",
                    "caption_file_url": null
                },
                {
                    "id": 109,
                    "level": 3,
                    "sets": 0,
                    "reps": "15",
                    "exercise_id": 20,
                    "created_at": "2021-02-23T08:12:10Z",
                    "updated_at": "2021-02-23T08:12:10Z",
                    "deprecated_at": null,
                    "equipment": [],
                    "duration_unit": "repetitions",
                    "duration_icon": "repetitions",
                    "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/exercises/Lying-core-strengthener-3.svg",
                    "video_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/lying-core-strengthener/level-3/videos.m3u8",
                    "video_thumbnail_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/lying-core-strengthener/level-3/thumbs_screen.0000089.jpg",
                    "variation_title": "Med vikter",
                    "instructions_icon_name": "repetitions",
                    "instructions_text1": null,
                    "instructions_text2": "repetitioner",
                    "instructions_text3": null,
                    "tip_title": "Anpassa övningen",
                    "tip_description": "Om övningen känns för tuff, kan du jobba med en arm i taget. Om övningen istället känns för lätt, kan du prova med tyngre vikter. Om du använder vattenflaskor kan du fylla dem med sand istället. \n",
                    "title": "Liggande bålstärkaren",
                    "about": "I denna övning tränar du främst de inre magmusklerna. Det är musklerna som går horisontellt som ett bälte över magen, samt de små muskler som går mellan kotorna i ryggen. Att vara stark i de inre musklerna ger kotpelaren ett stöd.",
                    "caption_file_url": null
                }
            ]
        },
        {
            "id": 21,
            "name": "sitting_core_strengthener",
            "exercise_number": 21,
            "created_at": "2021-02-23T08:12:10Z",
            "updated_at": "2021-02-23T08:12:10Z",
            "duration_minutes": 0,
            "target_joints": [
                "lower_back"
            ],
            "primary_function": "strength",
            "premium": false,
            "introduction_protocol_week": 1,
            "end_protocol_week": null,
            "levels": [
                {
                    "id": 111,
                    "level": 1,
                    "sets": 0,
                    "reps": "15",
                    "exercise_id": 21,
                    "created_at": "2021-02-23T08:12:10Z",
                    "updated_at": "2021-02-23T08:12:10Z",
                    "deprecated_at": null,
                    "equipment": [],
                    "duration_unit": "repetitions",
                    "duration_icon": "repetitions",
                    "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/exercises/Sitting-core-strengthener-1.svg",
                    "video_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/sitting-core-strengthener/level-1/videos.m3u8",
                    "video_thumbnail_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/sitting-core-strengthener/level-1/thumbs_screen.0000120.jpg",
                    "variation_title": null,
                    "instructions_icon_name": "repetitions",
                    "instructions_text1": null,
                    "instructions_text2": "repetitioner",
                    "instructions_text3": null,
                    "tip_title": "Anpassa övningen",
                    "tip_description": "Om du utför övningen på en pilatesboll istället för en stol får du extra bålträning eftersom du behöver balansera på bollen.\n\nEtt annat sätt är att lyfta en arm i taget med vikter.",
                    "title": "Sittande bålstärkaren",
                    "about": "Den här övningen tränar dina inre djupa magmuskler som är viktiga för att stabilisera hela bålen.",
                    "caption_file_url": null
                },
                {
                    "id": 112,
                    "level": 2,
                    "sets": 0,
                    "reps": "15",
                    "exercise_id": 21,
                    "created_at": "2021-02-23T08:12:10Z",
                    "updated_at": "2021-02-23T08:12:10Z",
                    "deprecated_at": null,
                    "equipment": [],
                    "duration_unit": "repetitions",
                    "duration_icon": "repetitions",
                    "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/exercises/Sitting-core-strengthener-2.svg",
                    "video_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/sitting-core-strengthener/level-2/videos.m3u8",
                    "video_thumbnail_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/sitting-core-strengthener/level-2/thumbs_screen.0000050.jpg",
                    "variation_title": "Med knälyft",
                    "instructions_icon_name": "repetitions",
                    "instructions_text1": "På varje sida",
                    "instructions_text2": "repetitioner",
                    "instructions_text3": null,
                    "tip_title": "Anpassa övningen",
                    "tip_description": "För en tuffare övning kan du lyfta armarna som du gjorde på nivå 1, samtidigt som du lyfter knäna.",
                    "title": "Sittande bålstärkaren",
                    "about": "Den här övningen tränar dina inre djupa magmuskler som är viktiga för att stabilisera hela bålen.",
                    "caption_file_url": null
                }
            ]
        },
        {
            "id": 22,
            "name": "lying_knee_raise",
            "exercise_number": 22,
            "created_at": "2021-02-23T08:12:10Z",
            "updated_at": "2021-02-23T08:12:10Z",
            "duration_minutes": 0,
            "target_joints": [
                "hip",
                "lower_back"
            ],
            "primary_function": "strength",
            "premium": false,
            "introduction_protocol_week": 1,
            "end_protocol_week": null,
            "levels": [
                {
                    "id": 114,
                    "level": 1,
                    "sets": 0,
                    "reps": "15",
                    "exercise_id": 22,
                    "created_at": "2021-02-23T08:12:10Z",
                    "updated_at": "2021-02-23T08:12:10Z",
                    "deprecated_at": null,
                    "equipment": [],
                    "duration_unit": "repetitions",
                    "duration_icon": "repetitions",
                    "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/exercises/Lying-knee-raise-1.svg",
                    "video_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/lying-knee-raise/level-1/videos.m3u8",
                    "video_thumbnail_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/lying-knee-raise/level-1/thumbs_screen.0000067.jpg",
                    "variation_title": null,
                    "instructions_icon_name": "repetitions",
                    "instructions_text1": "På varje sida",
                    "instructions_text2": "repetitioner",
                    "instructions_text3": null,
                    "tip_title": "Kom igång",
                    "tip_description": "Håll fingrarna precis innanför höftkammen och känn efter att du verkligen aktiverar magmusklerna. Tänk på att utföra rörelsen långsamt.\n\nDu kan även göra den här övningen i en fast säng eller soffa.",
                    "title": "Liggande knälyft",
                    "about": "Magmusklerna ligger i fyra olika lager. Det är viktigt att det finns en balans mellan de inre och yttre magmusklerna och det krävs olika övningar för att komma åt dem på ett effektivt sätt. \n\nPå nivå 1 tränar du främst de inre magmusklerna. På nivå 2 aktiveras även de yttre magmusklerna. På nivå 3 jobbar du med de yttre raka och sneda magmusklerna. ",
                    "caption_file_url": null
                },
                {
                    "id": 115,
                    "level": 2,
                    "sets": 0,
                    "reps": "15",
                    "exercise_id": 22,
                    "created_at": "2021-02-23T08:12:10Z",
                    "updated_at": "2021-02-23T08:12:10Z",
                    "deprecated_at": null,
                    "equipment": [],
                    "duration_unit": "repetitions",
                    "duration_icon": "repetitions",
                    "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/exercises/Lying-knee-raise-2.svg",
                    "video_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/lying-knee-raise/level-2/videos.m3u8",
                    "video_thumbnail_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/lying-knee-raise/level-2/thumbs_screen.0000100.jpg",
                    "variation_title": "Med bensträckning",
                    "instructions_icon_name": "repetitions",
                    "instructions_text1": "På varje sida",
                    "instructions_text2": "repetitioner",
                    "instructions_text3": null,
                    "tip_title": "Anpassa övningen",
                    "tip_description": "Ju närmare golvet du kommer med det sträckta benet, desto tyngre är övningen. Utför gärna rörelsen långsamt. ",
                    "title": "Liggande knälyft",
                    "about": "Magmusklerna ligger i fyra olika lager. Det är viktigt att det finns en balans mellan de inre och yttre magmusklerna och det krävs olika övningar för att komma åt dem på ett effektivt sätt. \n\nPå nivå 1 tränar du främst de inre magmusklerna. På nivå 2 aktiveras även de yttre magmusklerna. På nivå 3 jobbar du med de yttre raka och sneda magmusklerna. ",
                    "caption_file_url": null
                },
                {
                    "id": 116,
                    "level": 3,
                    "sets": 0,
                    "reps": "15",
                    "exercise_id": 22,
                    "created_at": "2021-02-23T08:12:10Z",
                    "updated_at": "2021-02-23T08:12:10Z",
                    "deprecated_at": null,
                    "equipment": [],
                    "duration_unit": "repetitions",
                    "duration_icon": "repetitions",
                    "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/exercises/Lying-knee-raise-3.svg",
                    "video_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/lying-knee-raise/level-3/videos.m3u8",
                    "video_thumbnail_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/lying-knee-raise/level-3/thumbs_screen.0000068.jpg",
                    "variation_title": "Knä mot armbåge",
                    "instructions_icon_name": "repetitions",
                    "instructions_text1": "På varje sida",
                    "instructions_text2": "repetitioner",
                    "instructions_text3": null,
                    "tip_title": "Kom ihåg",
                    "tip_description": "Kom ihåg att inte dra i nacken utan bara hålla händerna vid huvudet för lätt stöd.  Utför gärna rörelsen långsamt. ",
                    "title": "Liggande knälyft",
                    "about": "Magmusklerna ligger i fyra olika lager. Det är viktigt att det finns en balans mellan de inre och yttre magmusklerna och det krävs olika övningar för att komma åt dem på ett effektivt sätt. \n\nPå nivå 1 tränar du främst de inre magmusklerna. På nivå 2 aktiveras även de yttre magmusklerna. På nivå 3 jobbar du med de yttre raka och sneda magmusklerna. ",
                    "caption_file_url": null
                }
            ]
        },
        {
            "id": 23,
            "name": "side_plank",
            "exercise_number": 23,
            "created_at": "2021-02-23T08:12:10Z",
            "updated_at": "2021-02-23T08:12:10Z",
            "duration_minutes": 0,
            "target_joints": [
                "hip",
                "lower_back"
            ],
            "primary_function": "strength",
            "premium": false,
            "introduction_protocol_week": 10,
            "end_protocol_week": null,
            "levels": [
                {
                    "id": 118,
                    "level": 1,
                    "sets": 0,
                    "reps": "30",
                    "exercise_id": 23,
                    "created_at": "2021-02-23T08:12:10Z",
                    "updated_at": "2021-02-23T08:12:10Z",
                    "deprecated_at": null,
                    "equipment": [],
                    "duration_unit": "seconds",
                    "duration_icon": "timer",
                    "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/exercises/Side-plank-1.svg",
                    "video_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/side-plank/level-1/videos.m3u8",
                    "video_thumbnail_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/side-plank/level-1/thumbs_screen.0000035.jpg",
                    "variation_title": null,
                    "instructions_icon_name": "timer",
                    "instructions_text1": "På varje sida, håll",
                    "instructions_text2": "sekunder",
                    "instructions_text3": null,
                    "tip_title": "Anpassa övningen",
                    "tip_description": "Om övningen känns för tuff kan du börja med att bara hålla positionen utan att röra armen.",
                    "title": "Sidoplankan",
                    "about": "Den här övningen tränar hela bålmuskulaturen - både de inre och yttre magmusklerna samt ryggmusklerna. Utöver det är övningen bra för axlarna och stabiliteten i skuldrorna.",
                    "caption_file_url": null
                },
                {
                    "id": 119,
                    "level": 2,
                    "sets": 0,
                    "reps": "30",
                    "exercise_id": 23,
                    "created_at": "2021-02-23T08:12:10Z",
                    "updated_at": "2021-02-23T08:12:10Z",
                    "deprecated_at": null,
                    "equipment": [],
                    "duration_unit": "seconds",
                    "duration_icon": "timer",
                    "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/exercises/Side-plank-2.svg",
                    "video_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/side-plank/level-2/videos.m3u8",
                    "video_thumbnail_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/side-plank/level-2/thumbs_screen.0000070.jpg",
                    "variation_title": "Med höftdipp",
                    "instructions_icon_name": "timer",
                    "instructions_text1": "På varje sida",
                    "instructions_text2": "sekunder",
                    "instructions_text3": null,
                    "tip_title": "Anpassa övningen",
                    "tip_description": "För balans, spreta med fingrarna och tryck handen mot golvet.",
                    "title": "Sidoplankan",
                    "about": "Den här övningen tränar hela bålmuskulaturen - både de inre och yttre magmusklerna samt ryggmusklerna. Utöver det är övningen bra för axlarna och stabiliteten i skuldrorna.",
                    "caption_file_url": null
                },
                {
                    "id": 120,
                    "level": 3,
                    "sets": 0,
                    "reps": "30",
                    "exercise_id": 23,
                    "created_at": "2021-02-23T08:12:10Z",
                    "updated_at": "2021-02-23T08:12:10Z",
                    "deprecated_at": null,
                    "equipment": [],
                    "duration_unit": "seconds",
                    "duration_icon": "timer",
                    "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/exercises/Side-plank-3.svg",
                    "video_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/side-plank/level-3/videos.m3u8",
                    "video_thumbnail_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/side-plank/level-3/thumbs_screen.0000062.jpg",
                    "variation_title": "Rak kropp",
                    "instructions_icon_name": "timer",
                    "instructions_text1": "På varje sida, håll",
                    "instructions_text2": "sekunder",
                    "instructions_text3": null,
                    "tip_title": "Anpassa övningen",
                    "tip_description": "Om övningen känns för tuff kan du börja med att bara hålla positionen utan att röra armen.",
                    "title": "Sidoplankan",
                    "about": "Den här övningen tränar hela bålmuskulaturen - både de inre och yttre magmusklerna samt ryggmusklerna. Utöver det är övningen bra för axlarna och stabiliteten i skuldrorna.",
                    "caption_file_url": null
                },
                {
                    "id": 121,
                    "level": 4,
                    "sets": 0,
                    "reps": "30",
                    "exercise_id": 23,
                    "created_at": "2021-02-23T08:12:10Z",
                    "updated_at": "2021-02-23T08:12:10Z",
                    "deprecated_at": null,
                    "equipment": [],
                    "duration_unit": "seconds",
                    "duration_icon": "timer",
                    "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/exercises/Side-plank-4.svg",
                    "video_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/side-plank/level-4/videos.m3u8",
                    "video_thumbnail_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/side-plank/level-4/thumbs_screen.0000039.jpg",
                    "variation_title": "Rak med höftdipp",
                    "instructions_icon_name": "timer",
                    "instructions_text1": "På varje sida",
                    "instructions_text2": "sekunder",
                    "instructions_text3": null,
                    "tip_title": null,
                    "tip_description": null,
                    "title": "Sidoplankan",
                    "about": "Den här övningen tränar hela bålmuskulaturen - både de inre och yttre magmusklerna samt ryggmusklerna. Utöver det är övningen bra för axlarna och stabiliteten i skuldrorna.",
                    "caption_file_url": null
                },
                {
                    "id": 122,
                    "level": 5,
                    "sets": 0,
                    "reps": "30",
                    "exercise_id": 23,
                    "created_at": "2021-02-23T08:12:10Z",
                    "updated_at": "2021-02-23T08:12:10Z",
                    "deprecated_at": null,
                    "equipment": [],
                    "duration_unit": "seconds",
                    "duration_icon": "timer",
                    "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/exercises/Side-plank-5.svg",
                    "video_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/side-plank/level-5/videos.m3u8",
                    "video_thumbnail_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/side-plank/level-5/thumbs_screen.0000075.jpg",
                    "variation_title": "Med rotation",
                    "instructions_icon_name": "timer",
                    "instructions_text1": "På varje sida",
                    "instructions_text2": "sekunder",
                    "instructions_text3": null,
                    "tip_title": null,
                    "tip_description": null,
                    "title": "Sidoplankan",
                    "about": "Den här övningen tränar hela bålmuskulaturen - både de inre och yttre magmusklerna samt ryggmusklerna. Utöver det är övningen bra för axlarna och stabiliteten i skuldrorna.",
                    "caption_file_url": null
                }
            ]
        },
        {
            "id": 24,
            "name": "plank",
            "exercise_number": 24,
            "created_at": "2021-02-23T08:12:10Z",
            "updated_at": "2021-02-23T08:12:10Z",
            "duration_minutes": 0,
            "target_joints": [
                "hip",
                "lower_back"
            ],
            "primary_function": "strength",
            "premium": false,
            "introduction_protocol_week": 6,
            "end_protocol_week": null,
            "levels": [
                {
                    "id": 124,
                    "level": 1,
                    "sets": 0,
                    "reps": "30",
                    "exercise_id": 24,
                    "created_at": "2021-02-23T08:12:10Z",
                    "updated_at": "2021-02-23T08:12:10Z",
                    "deprecated_at": null,
                    "equipment": [],
                    "duration_unit": "seconds",
                    "duration_icon": "timer",
                    "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/exercises/Plank-1.svg",
                    "video_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/plank/level-1/videos.m3u8",
                    "video_thumbnail_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/plank/level-1/thumbs_screen.0000050.jpg",
                    "variation_title": null,
                    "instructions_icon_name": "timer",
                    "instructions_text1": "Håll i",
                    "instructions_text2": "sekunder",
                    "instructions_text3": null,
                    "tip_title": "Anpassa övningen",
                    "tip_description": "Lägg något mjukt under knäna vid behov. För en lite tuffare övning, prova att flytta knäna ett par decimeter längre bak och håll en rak linje från axlar till knäna.",
                    "title": "Plankan",
                    "about": "Här tränar du först och främst de raka och sneda magmusklerna samt skuldermuskulaturen. ",
                    "caption_file_url": null
                },
                {
                    "id": 125,
                    "level": 2,
                    "sets": 0,
                    "reps": "30",
                    "exercise_id": 24,
                    "created_at": "2021-02-23T08:12:10Z",
                    "updated_at": "2021-02-23T08:12:10Z",
                    "deprecated_at": null,
                    "equipment": [],
                    "duration_unit": "seconds",
                    "duration_icon": "timer",
                    "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/exercises/Plank-2.svg",
                    "video_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/plank/level-2/videos.m3u8",
                    "video_thumbnail_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/plank/level-2/thumbs_screen.0000065.jpg",
                    "variation_title": "På tårna",
                    "instructions_icon_name": "timer",
                    "instructions_text1": "Håll i",
                    "instructions_text2": "sekunder",
                    "instructions_text3": null,
                    "tip_title": null,
                    "tip_description": null,
                    "title": "Plankan",
                    "about": "Här tränar du först och främst de raka och sneda magmusklerna samt skuldermuskulaturen. ",
                    "caption_file_url": null
                }
            ]
        },
        {
            "id": 25,
            "name": "push_ups",
            "exercise_number": 25,
            "created_at": "2021-02-23T08:12:10Z",
            "updated_at": "2021-02-23T08:12:10Z",
            "duration_minutes": 0,
            "target_joints": [
                "lower_back",
                "shoulder"
            ],
            "primary_function": "strength",
            "premium": false,
            "introduction_protocol_week": 4,
            "end_protocol_week": null,
            "levels": [
                {
                    "id": 127,
                    "level": 1,
                    "sets": 0,
                    "reps": "15",
                    "exercise_id": 25,
                    "created_at": "2021-02-23T08:12:10Z",
                    "updated_at": "2021-02-23T08:12:10Z",
                    "deprecated_at": null,
                    "equipment": [],
                    "duration_unit": "repetitions",
                    "duration_icon": "repetitions",
                    "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/exercises/Push-ups-1.svg",
                    "video_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/push-ups/level-1/videos.m3u8",
                    "video_thumbnail_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/push-ups/level-1/thumbs_screen.0000062.jpg",
                    "variation_title": null,
                    "instructions_icon_name": "repetitions",
                    "instructions_text1": null,
                    "instructions_text2": "repetitioner",
                    "instructions_text3": null,
                    "tip_title": "Kom igång",
                    "tip_description": "Se till att fötterna inte glider på golvet. Det viktigaste är dock att du spänner bålen genom hela övningen.  ",
                    "title": "Armhävningar",
                    "about": "Här tränar du bålmusklerna men även bröstmusklerna och axlarna. ",
                    "caption_file_url": null
                },
                {
                    "id": 128,
                    "level": 2,
                    "sets": 0,
                    "reps": "15",
                    "exercise_id": 25,
                    "created_at": "2021-02-23T08:12:10Z",
                    "updated_at": "2021-02-23T08:12:10Z",
                    "deprecated_at": null,
                    "equipment": [],
                    "duration_unit": "repetitions",
                    "duration_icon": "repetitions",
                    "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/exercises/Push-ups-2.svg",
                    "video_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/push-ups/level-2/videos.m3u8",
                    "video_thumbnail_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/push-ups/level-2/thumbs_screen.0000050.jpg",
                    "variation_title": "Händerna lägre",
                    "instructions_icon_name": "repetitions",
                    "instructions_text1": null,
                    "instructions_text2": "repetitioner",
                    "instructions_text3": null,
                    "tip_title": "Kom igång",
                    "tip_description": "Se till att fötterna inte glider på golvet. Det viktigaste är dock att du spänner bålen genom hela övningen.  ",
                    "title": "Armhävningar",
                    "about": "Här tränar du bålmusklerna men även bröstmusklerna och axlarna. ",
                    "caption_file_url": null
                },
                {
                    "id": 129,
                    "level": 3,
                    "sets": 0,
                    "reps": "15",
                    "exercise_id": 25,
                    "created_at": "2021-02-23T08:12:10Z",
                    "updated_at": "2021-02-23T08:12:10Z",
                    "deprecated_at": null,
                    "equipment": [],
                    "duration_unit": "repetitions",
                    "duration_icon": "repetitions",
                    "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/exercises/Push-ups-3.svg",
                    "video_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/push-ups/level-3/videos.m3u8",
                    "video_thumbnail_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/push-ups/level-3/thumbs_screen.0000050.jpg",
                    "variation_title": "Mot bänk",
                    "instructions_icon_name": "repetitions",
                    "instructions_text1": null,
                    "instructions_text2": "repetitioner",
                    "instructions_text3": null,
                    "tip_title": "Anpassa övningen",
                    "tip_description": "Se till att fötterna inte glider på golvet. För en tuffare variant kan du använda en lägre möbel. ",
                    "title": "Armhävningar",
                    "about": "Här tränar du bålmusklerna men även bröstmusklerna och axlarna. ",
                    "caption_file_url": null
                }
            ]
        },
        {
            "id": 33,
            "name": "standing_row",
            "exercise_number": 33,
            "created_at": null,
            "updated_at": "2025-03-18T13:53:29Z",
            "duration_minutes": 0,
            "target_joints": [
                "lower_back",
                "neck",
                "shoulder"
            ],
            "primary_function": "strength",
            "premium": false,
            "introduction_protocol_week": 12,
            "end_protocol_week": null,
            "levels": [
                {
                    "id": 145,
                    "level": 1,
                    "sets": 0,
                    "reps": "15",
                    "exercise_id": 33,
                    "created_at": "2021-07-12T12:29:28Z",
                    "updated_at": "2021-07-12T12:29:28Z",
                    "deprecated_at": null,
                    "equipment": [
                        "resistance_band"
                    ],
                    "duration_unit": "repetitions",
                    "duration_icon": "repetitions",
                    "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/exercises/Standing-row-1.svg",
                    "video_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20220309/sv/standing-row/level-1/videos.m3u8",
                    "video_thumbnail_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20220309/sv/standing-row/level-1/thumbs_screen.0000075.jpg",
                    "variation_title": null,
                    "instructions_icon_name": "repetitions",
                    "instructions_text1": null,
                    "instructions_text2": "repetitioner",
                    "instructions_text3": null,
                    "tip_title": "Kom igång",
                    "tip_description": "För en tuffare övning, kan du ta ett steg längre bak för att öka spänningen i gummibandet eller byta till ett gummiband med mer motstånd.\n\nOm du har svårt att hitta ställen att fästa bandet på, är ett tips att använda ett så kallat dörrankare. Du skulle även kunna trä bandet runt ett gångjärn på en dörr. Hittar du inget högt ställa att fästa bandet på, kan du fästa det i ett dörrhandtag. ",
                    "title": "Stående rodd",
                    "about": "Det är viktigt att ha starka bålmuskler när vi står, går och vrider på oss. I denna övning arbetar du med inre och yttre magmusklerna, samt kommer åt de sneda musklerna på sidorna. ",
                    "caption_file_url": null
                }
            ]
        },
        {
            "id": 34,
            "name": "standing_core_strengthener",
            "exercise_number": 34,
            "created_at": null,
            "updated_at": "2025-03-18T13:53:29Z",
            "duration_minutes": 0,
            "target_joints": [
                "lower_back"
            ],
            "primary_function": "strength",
            "premium": false,
            "introduction_protocol_week": 14,
            "end_protocol_week": null,
            "levels": [
                {
                    "id": 147,
                    "level": 1,
                    "sets": 0,
                    "reps": "15",
                    "exercise_id": 34,
                    "created_at": "2021-07-12T12:29:28Z",
                    "updated_at": "2021-07-12T12:29:28Z",
                    "deprecated_at": null,
                    "equipment": [
                        "resistance_band"
                    ],
                    "duration_unit": "repetitions",
                    "duration_icon": "repetitions",
                    "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/exercises/Standing-core-strengthener-1.svg",
                    "video_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/standing-core-strengthener/level-1/videos.m3u8",
                    "video_thumbnail_file_url": "https://d3dnlpb0rds8qr.cloudfront.net/v20210609/sv/standing-core-strengthener/level-1/thumbs_screen.0000070.jpg",
                    "variation_title": null,
                    "instructions_icon_name": "repetitions",
                    "instructions_text1": "Åt varje sida",
                    "instructions_text2": "repetitioner",
                    "instructions_text3": "Växla mellan höger och vänster",
                    "tip_title": "Kom igång",
                    "tip_description": "Se till att axlar och nacke är avslappnade när du utför övningen.\n\nDet går lika bra att använda hantlar istället om du föredrar det.",
                    "title": "Stående bålstärkaren",
                    "about": "I denna övning lär du dig hur du stående kan aktivera de magmuskler som du redan har jobbat med liggande. När du har lärt dig aktivera de inre magmusklerna kommer de att aktiveras automatiskt vid behov i vardagen, som vid lyft, vridningar, osv. ",
                    "caption_file_url": null
                }
            ]
        }
    ],
    "lessons": [
        {
            "id": 10,
            "title": "Om motivation",
            "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/10.staying motivated-02af1fca40f8f14bc1390fe20fde7500d35f9ca95200ce3688e602f591ef2406.svg",
            "parts_count": 2,
            "target_joints": [
                "hip",
                "knee",
                "lower_back",
                "shoulder",
                "neck",
                "foot",
                "elbow",
                "hand"
            ]
        },
        {
            "id": 13,
            "title": "Styrke- & konditionsträning",
            "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/13.createyourowntrainingprogram-3a9107db6b6daa83f5f03386cb536433e4035ce7a2bf09b462bdad73dfd95994.svg",
            "parts_count": 3,
            "target_joints": [
                "hip",
                "knee",
                "lower_back"
            ]
        },
        {
            "id": 14,
            "title": "Hälsosam kost",
            "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/14.eathealthywithoutthinkingaboutit-0668cfeb7a9182330dc2475ef864163e7793e37c912f83af784e6694c5b6ee1c.svg",
            "parts_count": 3,
            "target_joints": [
                "hip",
                "knee",
                "lower_back"
            ]
        },
        {
            "id": 22,
            "title": "Att hantera motgångar",
            "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/24.setbacksarecompletelynormal-dbfa89eb52f1a88d13f61f273d6c416fa5d5469fea10e73dd20c3f4f6e5cacb3.svg",
            "parts_count": 2,
            "target_joints": [
                "hip",
                "knee",
                "lower_back"
            ]
        },
        {
            "id": 25,
            "title": "Roligare träning",
            "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/27.howtomaketrtainingmorefun-1c4edd32d94517b6afad5b8b6923a1d56d024e94fb053596ddd8dbb91d677ef6.svg",
            "parts_count": 1,
            "target_joints": [
                "hip",
                "knee",
                "lower_back"
            ]
        },
        {
            "id": 27,
            "title": "Om ländryggssmärta",
            "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp01.aboutbackpain-fcbee4881417b91e3634c8f791c10f4102168f66bc816e3d8dbd231c25be00e3.svg",
            "parts_count": 3,
            "target_joints": [
                "lower_back"
            ]
        },
        {
            "id": 28,
            "title": "Vägen till en diagnos",
            "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp02.gettingadiagnosis-0d35be2610be620ec1694c3016b70b228fa9296a0880a248eafc5fec35df40b4.svg",
            "parts_count": 2,
            "target_joints": [
                "lower_back"
            ]
        },
        {
            "id": 29,
            "title": "Ryggens anatomi ",
            "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp03.atonomiofthespine-454427f67e4ba10b8b12c17c3c41eac36bf4d2f7ceedf725a2cad8d8b742f521.svg",
            "parts_count": 4,
            "target_joints": [
                "lower_back"
            ]
        },
        {
            "id": 30,
            "title": "Vanliga orsaker till ryggsmärta",
            "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp04.commoncausesofbackpain-93ef58d24f4c7b1fca5cf93127cf2ea3704a316593c5f79ef57ea5d04fc9d793.svg",
            "parts_count": 4,
            "target_joints": [
                "lower_back"
            ]
        },
        {
            "id": 31,
            "title": "Mindre vanliga orsaker till ryggsmärta",
            "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp05.lesscommoncausesofbackpain-63c996b917b1acc42ffde1111d865cebdc448b8f309cd70de54278f56034f344.svg",
            "parts_count": 2,
            "target_joints": [
                "lower_back"
            ]
        },
        {
            "id": 32,
            "title": "Om smärta",
            "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp06.aboutpain-a478458b86496bd61df3666f294d2579751763417bb8186e4710a7e3b9bb49f6.svg",
            "parts_count": 3,
            "target_joints": [
                "lower_back"
            ]
        },
        {
            "id": 33,
            "title": "Smärthantering",
            "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp07.painmanagement-6c9985e6694d8947b16e47bec1e7bb992aa8f9c131f0d1fce14bd017306a3561.svg",
            "parts_count": 3,
            "target_joints": [
                "lower_back"
            ]
        },
        {
            "id": 34,
            "title": "Rörelserädsla",
            "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp08.fearofmovement-6091094bdaf04cf31850a6523fce6a9a8741cefd852c60ec16b1df1add4eee5b.svg",
            "parts_count": 2,
            "target_joints": [
                "lower_back"
            ]
        },
        {
            "id": 35,
            "title": "Ergonomi ",
            "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp09.ergonomics-bceff7e0b2cc8a65e9e5be1feddcf3ec091c6e5087c5a1b88637aa054f2a7c9c.svg",
            "parts_count": 4,
            "target_joints": [
                "lower_back"
            ]
        },
        {
            "id": 36,
            "title": "Fysisk aktivitet & ryggsmärta",
            "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp10.physicalactivitybackpain-0628e7252c03e13a4f12a8f20815966ded01093c05e05dbad15cd11e71784dbd.svg",
            "parts_count": 2,
            "target_joints": [
                "lower_back"
            ]
        },
        {
            "id": 37,
            "title": "Träning & ryggbesvär",
            "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp11.exercisebackpain-1344f8a0d30e4a5e438e8c81f742c409a063563cc2af0ba4dbdd2eb05cff7ed7.svg",
            "parts_count": 3,
            "target_joints": [
                "lower_back"
            ]
        },
        {
            "id": 38,
            "title": "Andra behandlingar",
            "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp12.othertreatmentoptions-9501c00d9a4e99a2911b9a377beee27f638cc12f324072de62fd6557fc53b3a1.svg",
            "parts_count": 3,
            "target_joints": [
                "lower_back"
            ]
        },
        {
            "id": 39,
            "title": "Om ryggoperation",
            "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp13.aboutlowbacksurgery-de7aaad154d83ed59dfcc38119c1990ee7f85fb62fdb85d1f7b3b0de689c4a0b.svg",
            "parts_count": 1,
            "target_joints": [
                "lower_back"
            ]
        },
        {
            "id": 40,
            "title": "Myter & sanningar",
            "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp14.mythsfacts-95c16b9c9380d18e846e88bd4e3ab99c6228102cd639d412724c9a9dc1a9f0ef.svg",
            "parts_count": 5,
            "target_joints": [
                "lower_back"
            ]
        },
        {
            "id": 41,
            "title": "Sömn & smärta",
            "image_url": "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp15.sleeppain-a42f41334523ac2497bed7d91e0f121d471d19843cd85c8aa2e6e7c1406117aa.svg",
            "parts_count": 1,
            "target_joints": [
                "lower_back"
            ]
        }
    ],
    "name": null,
    "key": "low_back_pain",
    "standardized": true,
    "functional_test": true,
    "health_form_type": "low_back_pain",
    "max_exercises_per_day": 2
}